const _ = require('lodash');

const findIndex = _.findIndex;

const asyncForEach = async (array, callback) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};
const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
const randomPin = () => Math.floor(1000 + Math.random() * 9000);

export { findIndex, asyncForEach, wait, randomPin };
